import { render, staticRenderFns } from "./AllTab.vue?vue&type=template&id=45bb5f26"
import script from "./AllTab.vue?vue&type=script&lang=js"
export * from "./AllTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports